import angular from 'angular';
import htmlTemplate from './person-timeline-entry-file.html';

export default angular
  .module('swoa.person.timeline.person-timeline-entry-file', [])
  .component('swoaPersonTimelineEntryFile', {
    template: htmlTemplate,
    bindings: {
      entry: '<',
      type: '<',
    },
    controllerAs: 'vm',
  })
  .name;
